<content>
  <form *ngIf="showLanguages" [formGroup]="languagesForm">
    <div class="entry">
      <label>{{'session.chooseLanguage' | translate}}</label>
      <app-filterable-list [itemsList]="languages" [selectedItem]="languagesForm.get('pais')" [placeHolder]="false">
      </app-filterable-list>
    </div>
  </form>
  <form *ngIf="showConfirmation">
    <div class="entry">
      <label>{{ 'session.warningChangeLanguage' | translate}}</label>
    </div>
  </form>
</content>
<footer class="button-bar-center">
  <button *ngIf="showLanguages" [disabled]="!this.languagesForm.get('pais').value" (click)="changeLanguage()">{{ 'global.confirmar' | translate}}</button>
  <button *ngIf="showConfirmation" (click)="confirm()">{{ 'global.confirmar' | translate}}</button>
</footer>
